import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang( '@shining3d/xl-design-order' );

const unitMap = {
    perPiece: $t('design.order.grainUnit') || '颗',
    perJaw: $t('design.order.jawUnit') || '颌',
    perCase: $t('design.order.caseUnit') || '案例',
    perHole: $t('design.order.holeUnit') || '孔'
};

const timeMap = {
    second: 's',
    minute: 'm',
    hour: 'h',
    day: 'd'
};

// 病例类型
const designTypeList = [
    { label: $t( 'design.case.repair' ) || '修复', value: 'repair' },
    { label: $t( 'design.case.implant' ) || '种植', value: 'implant' },
    { label: $t( 'design.case.orthodontic' ) || '正畸', value: 'orthodontic' },
    { label: $t( 'design.case.removableDenture' ) || '活动义齿', value: 'removableDenture' },
    { label: $t( 'design.case.aesthetics' ) || '美学', value: 'aesthetics' }, // 美学
    { label: $t( 'design.case.maxillofacial' ) || '颌面', value: 'maxillofacial' }, // 颌面
    { label: $t( 'design.other' ) || '其他', value: 'other' }
];

const toothNameMap = {
    upperJaw: $t('design.toothUpperJaw') || "上颌",
    lowerJaw: $t('design.toothLowerJaw') || "下颌",
    perCase: $t('design.fullJaw') || "全颌"
};

export {
    unitMap,
    timeMap,
    designTypeList,
    toothNameMap
}